import React, { FC, ImgHTMLAttributes, PropsWithChildren } from 'react';
import styled, { CSSProperties } from 'styled-components';

const StyledTag = styled.img(({ xs, sm, md, lg }: ResponsiveStyle) => {
    return {
        ...xs,
        '@media (max-width: 600px)': { ...sm },
        '@media (max-width: 900px)': { ...md },
        '@media (max-width: 1200px)': { ...lg },
    };
});

export interface ResponsiveStyle extends ImgHTMLAttributes<HTMLImageElement> {
    xs?: CSSProperties;
    sm?: CSSProperties;
    md?: CSSProperties;
    lg?: CSSProperties;
}

const ImgTag: FC<PropsWithChildren<ResponsiveStyle>> = ({ ...props }) => {
    return <StyledTag {...props} />;
};

export default ImgTag;
